import { atom } from "jotai";

import { TaskViewType } from "../shared/dashboard";
import { dateAsDayjs, DateType } from "../utils/date";

export const adminDashboardSelectedDateAtom = atom<DateType>(dateAsDayjs());
export const adminDashboardSelectedDriverIdAtom = atom("");
export const adminDashboardSelectedTaskViewAtom = atom<TaskViewType>("all");
export const adminDashboardShowDriverManagersAtom = atom<boolean>(false);
export const isDriverReviewingTaskAtom = atom<boolean>(false);
export const isDriverReviewingJunkLoadAtom = atom<boolean>(false);
